// Package assets.v3 defines the protocol buffer messages and services for asset management
// within the platform. Assets are files uploaded by users that go through processing
// lifecycles including extraction, transcription, summarization, and embedding generation.

// @generated by protoc-gen-es v2.2.5 with parameter "target=ts"
// @generated from file assets/v3/asset.proto (package assets.v3, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import type { AuditMetadata } from "../../common/v3/common_pb";
import { file_common_v3_common } from "../../common/v3/common_pb";
import type { LabelSummary } from "../../labels/v3/label_pb";
import { file_labels_v3_label } from "../../labels/v3/label_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file assets/v3/asset.proto.
 */
export const file_assets_v3_asset: GenFile = /*@__PURE__*/
  fileDesc("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", [file_common_v3_common, file_labels_v3_label, file_google_protobuf_timestamp]);

/**
 * ProcessingMetadata contains metadata about a processing step.
 *
 * @generated from message assets.v3.ProcessingMetadata
 */
export type ProcessingMetadata = Message<"assets.v3.ProcessingMetadata"> & {
  /**
   * When the processing step occurred
   *
   * @generated from field: google.protobuf.Timestamp occurred_at = 1;
   */
  occurredAt: Timestamp;

  /**
   * When the processing step started
   *
   * @generated from field: google.protobuf.Timestamp start_at = 2;
   */
  startAt: Timestamp;

  /**
   * When the processing step completed
   *
   * @generated from field: optional google.protobuf.Timestamp completed_at = 3;
   */
  completedAt: Timestamp;

  /**
   * When the processing step failed
   *
   * @generated from field: optional google.protobuf.Timestamp failed_at = 4;
   */
  failedAt: Timestamp;

  /**
   * Reason for failure, if any
   *
   * @generated from field: string failed_reason = 5;
   */
  failedReason: string;

  /**
   * HTTP status code, if applicable
   *
   * @generated from field: int32 status_code = 6;
   */
  statusCode: number;

  /**
   * Processing step name
   *
   * @generated from field: string step = 7;
   */
  step: string;

  /**
   * Number of attempts or iterations
   *
   * @generated from field: int32 count = 8;
   */
  count: number;

  /**
   * Processing message
   *
   * @generated from field: string message = 9;
   */
  message: string;
};

/**
 * Describes the message assets.v3.ProcessingMetadata.
 * Use `create(ProcessingMetadataSchema)` to create a new message.
 */
export const ProcessingMetadataSchema: GenMessage<ProcessingMetadata> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset, 0);

/**
 * Embedding represents an embedding vector for an asset.
 *
 * @generated from message assets.v3.Embedding
 */
export type Embedding = Message<"assets.v3.Embedding"> & {
  /**
   * Current state of the embedding
   *
   * @generated from field: assets.v3.AssetLifecycleState state = 1;
   */
  state: AssetLifecycleState;

  /**
   * Model used to generate the embedding
   *
   * @generated from field: string model = 2;
   */
  model: string;
};

/**
 * Describes the message assets.v3.Embedding.
 * Use `create(EmbeddingSchema)` to create a new message.
 */
export const EmbeddingSchema: GenMessage<Embedding> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset, 1);

/**
 * Asset represents a file uploaded by users that goes through processing lifecycles.
 *
 * @generated from message assets.v3.Asset
 */
export type Asset = Message<"assets.v3.Asset"> & {
  /**
   * Unique identifier for the asset
   * Format: ^asset_[a-z0-9]{20}$
   *
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * Version number for optimistic concurrency control
   *
   * @generated from field: int64 version = 2;
   */
  version: bigint;

  /**
   * ETag for optimistic concurrency control
   *
   * @generated from field: string etag = 3;
   */
  etag: string;

  /**
   * ID of the organization that owns this asset
   * Format: ^organization_[a-z0-9]{20}$
   *
   * @generated from field: string organization_id = 4;
   */
  organizationId: string;

  /**
   * ID of the tenant this asset belongs to
   * Format: ^organization_[a-z0-9]{20}$
   *
   * @generated from field: string tenant_id = 5;
   */
  tenantId: string;

  /**
   * ID of the workspace this asset belongs to
   * Format: ^organization_[a-z0-9]{20}$
   *
   * @generated from field: string workspace_id = 6;
   */
  workspaceId: string;

  /**
   * ID of the project this asset belongs to
   * Format: ^organization_[a-z0-9]{20}$
   *
   * @generated from field: string project_id = 7;
   */
  projectId: string;

  /**
   * Original filename as provided by the user
   *
   * @generated from field: string original_filename = 8;
   */
  originalFilename: string;

  /**
   * Display name for the asset (may be derived from content)
   *
   * @generated from field: string display_name = 9;
   */
  displayName: string;

  /**
   * Current lifecycle state of the asset
   *
   * @generated from field: assets.v3.AssetLifecycleState lifecycle_state = 10;
   */
  lifecycleState: AssetLifecycleState;

  /**
   * Summary of the asset content (max 2048 characters)
   *
   * @generated from field: string summary = 11;
   */
  summary: string;

  /**
   * Size of the file in bytes
   *
   * @generated from field: int64 file_size = 12;
   */
  fileSize: bigint;

  /**
   * Number of tokens in the asset's text content
   *
   * @generated from field: int64 text_tokens = 13;
   */
  textTokens: bigint;

  /**
   * MIME type of the file
   *
   * @generated from field: string content_type = 14;
   */
  contentType: string;

  /**
   * Temporary signed URL for accessing the asset
   *
   * @generated from field: string signed_url = 15;
   */
  signedUrl: string;

  /**
   * Reason for processing failure, if any
   *
   * @generated from field: string failure_reason = 16;
   */
  failureReason: string;

  /**
   * Current processing message
   *
   * @generated from field: string processing_message = 17;
   */
  processingMessage: string;

  /**
   * Current processing error message
   *
   * @generated from field: string processing_error_message = 18;
   */
  processingErrorMessage: string;

  /**
   * Token counts for the extracted text
   *
   * @generated from field: int64 text_token_count = 19;
   */
  textTokenCount: bigint;

  /**
   * Timestamps
   *
   * @generated from field: google.protobuf.Timestamp uploaded_at = 20;
   */
  uploadedAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_ready_at = 21;
   */
  lastReadyAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp last_referenced_at = 22;
   */
  lastReferencedAt?: Timestamp;

  /**
   * Audit metadata
   *
   * @generated from field: common.v3.AuditMetadata audit_metadata = 23;
   */
  auditMetadata?: AuditMetadata;

  /**
   * Labels associated with this asset
   *
   * @generated from field: repeated string label_ids = 24;
   */
  labelIds: string[];

  /**
   * Soft delete information
   *
   * @generated from field: optional google.protobuf.Timestamp deleted_at = 25;
   */
  deletedAt?: Timestamp;

  /**
   * Format: ^user_[a-z0-9]{20}$
   *
   * @generated from field: optional string deleted_by = 26;
   */
  deletedBy?: string;
};

/**
 * Describes the message assets.v3.Asset.
 * Use `create(AssetSchema)` to create a new message.
 */
export const AssetSchema: GenMessage<Asset> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset, 2);

/**
 * AssetWithLabels represents an asset with its associated label details.
 *
 * @generated from message assets.v3.AssetWithLabels
 */
export type AssetWithLabels = Message<"assets.v3.AssetWithLabels"> & {
  /**
   * The asset
   *
   * @generated from field: assets.v3.Asset asset = 1;
   */
  asset: Asset;

  /**
   * Labels associated with this asset
   *
   * @generated from field: repeated labels.v3.LabelSummary labels = 2;
   */
  labels: LabelSummary[];
};

/**
 * Describes the message assets.v3.AssetWithLabels.
 * Use `create(AssetWithLabelsSchema)` to create a new message.
 */
export const AssetWithLabelsSchema: GenMessage<AssetWithLabels> = /*@__PURE__*/
  messageDesc(file_assets_v3_asset, 3);

/**
 * AssetLifecycleState represents the current processing state of an asset.
 * Assets progress through these states as they are processed by the platform.
 *
 * @generated from enum assets.v3.AssetLifecycleState
 */
export enum AssetLifecycleState {
  /**
   * @generated from enum value: ASSET_LIFECYCLE_STATE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Asset is waiting to be uploaded
   *
   * @generated from enum value: ASSET_LIFECYCLE_STATE_AWAITING_UPLOAD = 1;
   */
  AWAITING_UPLOAD = 1,

  /**
   * Asset has been uploaded but not yet processed
   *
   * @generated from enum value: ASSET_LIFECYCLE_STATE_UPLOADED = 2;
   */
  UPLOADED = 2,

  /**
   * Asset is queued for processing
   *
   * @generated from enum value: ASSET_LIFECYCLE_STATE_QUEUED_FOR_PROCESSING = 3;
   */
  QUEUED_FOR_PROCESSING = 3,

  /**
   * Asset is being processed
   *
   * @generated from enum value: ASSET_LIFECYCLE_STATE_PROCESSING = 4;
   */
  PROCESSING = 4,

  /**
   * Asset is ready for use
   *
   * @generated from enum value: ASSET_LIFECYCLE_STATE_READY = 5;
   */
  READY = 5,

  /**
   * Asset processing failed
   *
   * @generated from enum value: ASSET_LIFECYCLE_STATE_FAILED = 6;
   */
  FAILED = 6,

  /**
   * Asset is being reprocessed after failure or update
   *
   * @generated from enum value: ASSET_LIFECYCLE_STATE_REPROCESSING = 7;
   */
  REPROCESSING = 7,

  /**
   * Asset has been archived
   *
   * @generated from enum value: ASSET_LIFECYCLE_STATE_ARCHIVED = 8;
   */
  ARCHIVED = 8,

  /**
   * Asset has been quarantined due to content policy violations
   *
   * @generated from enum value: ASSET_LIFECYCLE_STATE_QUARANTINED = 9;
   */
  QUARANTINED = 9,

  /**
   * Asset deletion has been requested
   *
   * @generated from enum value: ASSET_LIFECYCLE_STATE_DELETE_REQUESTED = 10;
   */
  DELETE_REQUESTED = 10,

  /**
   * Asset has been deleted
   *
   * @generated from enum value: ASSET_LIFECYCLE_STATE_DELETED = 11;
   */
  DELETED = 11,

  /**
   * Asset blocked from processing due to a lack of balance.
   *
   * @generated from enum value: ASSET_LIFECYCLE_STATE_TOO_MANY_REQUESTS = 12;
   */
  TOO_MANY_REQUESTS = 12,
}

/**
 * Describes the enum assets.v3.AssetLifecycleState.
 */
export const AssetLifecycleStateSchema: GenEnum<AssetLifecycleState> = /*@__PURE__*/
  enumDesc(file_assets_v3_asset, 0);

